import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

/** CRA `homepage` / `PUBLIC_URL` subpath deploys (e.g. GitHub Pages) need a matching basename. */
const routerBasename =
  (process.env.PUBLIC_URL || '').replace(/\/$/, '') || undefined;

root.render(
  <React.StrictMode>
    <BrowserRouter basename={routerBasename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
